// extracted by mini-css-extract-plugin
export default {"time":"Gf98b60"};